<template>
  <div class="com_login">
    <div class="login_title">下单方登录/注册</div>
    <!-- <el-input v-model="phoneNumber" placeholder="请输入手机号" type="text" maxlength="13" @change="phoneChange"></el-input> -->
    <a-input
      placeholder="请输入手机号"
      @change="phoneChange"
      :value="phoneNumber"
      npaste="return false"
      oncontextmenu="return false"
      oncopy="return false"
      oncut="return false"
      :maxLength="13"
      :class="{ phonenum: phoneFormat }"
    />
    <div class="errphone" v-if="phoneFormat">手机号格式有误</div>
    <el-input
      v-model="verificationCode"
      placeholder="请输入验证码"
      maxlength="13"
    >
      <span
        v-if="getYzm"
        slot="suffix"
        :class="{ get_yzm: phoneTrueValue.length == 11 ? true : false }"
        @click="btnClick()"
        >{{ yzmTtext }}</span
      >
      <span v-else slot="suffix">{{ yzmTime }}S后重发</span>
    </el-input>
    <el-row>
      <el-button :disabled="buttom" @click="login()" class="zhuce"
        >登录</el-button
      >
    </el-row>
    <div class="register">
      <span @click="hrefRegister()">新用户注册</span>
    </div>
    <Geet :isGeet="isgt" @geetPath="onGeetestValCodePath" @clickChange="onGeetChange"></Geet>
  </div>
</template>

<script>
import Geet from "./Geet.vue";
import { geetestValCodeMixin } from "../../mixins/geetestValCodeMixin";
export default {
  mixins: [geetestValCodeMixin],
  data() {
    return {
      phoneNumber: "",
      phoneTrueValue: "",
      verificationCode: "",
      yzmNumber: "",
      buttom: true,
      getYzm: true,
      yzmImg: false,
      yzmTime: 60,
      yzmTtext: "发送验证码",
      phoneFormat: false
    };
  },
  components: {
    Geet
  },
  mounted() {},
  watch: {
    phoneNumber(newValue, oldValue) {
      if (newValue > oldValue) {
        if (newValue.length === 4 || newValue.length === 9) {
          var pre = newValue.substring(0, newValue.length - 1);
          var last = newValue.substr(newValue.length - 1, 1);
          this.phoneNumber = pre + " " + last;
        } else {
          this.phoneNumber = newValue;
        }
      } else {
        if (newValue.length === 9 || newValue.length === 4) {
          this.phoneNumber = this.phoneNumber.trim();
        } else {
          this.phoneNumber = newValue;
        }
      }
      if (this.phoneNumber.length == 13) {
        if (this.yzmImg) {
          this.buttom = false;
        }
      } else {
        this.buttom = true;
        this.phoneFormat = false;
      }
    }
  },
  methods: {
    btnClick() {
      console.log("2,按钮被点击，进行图形验证");
      var myreg = /^1[123456789]\d{9}$/;
      if (this.phoneTrueValue.length == 11) {
        if (myreg.test(this.phoneTrueValue)) {
          this.requestValCodeV2(this.phoneTrueValue, "login");
        } else {
          this.phoneFormat = true;
        }
      }
    },
    onValCodeSent() {
      this.yzmTimeMinuse();
    },
    // phone改变
    phoneChange(e) {
      if (e.data && !e.data.replace(/[^\d]/g, "")) {
        return;
      }
      this.phoneNumber = e.target.value;
      // const reg = /^1[0-9]{10}$/;
      this.phoneTrueValue = this.phoneNumber.replace(/\s+/g, "");
      // this.phoneBool = reg.test(this.phoneTrueValue);
    },
    //验证码倒计时
    yzmTimeMinuse() {
      this.$message.closeAll();
      var _this = this;
      var myreg = /^1[123456789]\d{9}$/;
      if (this.phoneTrueValue.length == 11) {
        if (myreg.test(this.phoneTrueValue)) {
          this.getYzm = false;
          this.yzmTime = 60;

          var auth_timetimer = setInterval(() => {
            this.yzmTime--;
            if (this.yzmTime <= 0) {
              this.getYzm = true;
              clearInterval(auth_timetimer);
              this.yzmTtext = "重新发送";
            }
          }, 1000);
          this.yzmImg = true;
          this.buttom = false;
        } else {
          this.phoneFormat = true;
        }
      }
    },
    // 跳转注册
    hrefRegister() {
      this.$router.push({ path: "/register" });
    },
    login() {
      this.$message.closeAll();
      var _this = this;
      this.$fetch(
        `/user/api/customer/login?username=${_this.phoneTrueValue}&code=${_this.verificationCode}`
      ).then(res => {
        if (res.code == 0) {
          Cookies.set("token", res.data.webToken, { expires: 30, path: "/" });
          this.$message({
            message: res.message,
            type: "success"
          });
          // 用户信息
          _this.$fetch(`/user/api/customer`).then(res => {
            if (res.code == 0) {
              _this.$store.state.userName = res.data.nickname;
              _this.$store.state.userPhone = res.data.username;
              _this.$store.state.userAvatar = res.data.avatar;
              _this.$store.state.hasPwd = res.data.hasPwd;
              _this.$store.state.userInfo = res.data;
              console.log(_this.$store.state.defaultUrl);
              if (_this.$store.state.defaultUrl == "") {
                _this.$router.push({ path: "/user/index" });
              } else {
                _this.$router.push({ path: _this.$store.state.defaultUrl });
              }
            } else {
              // this.$message(res.message);
            }
          });
        } else {
          this.$message(res.message);
        }
      });
    }
  }
};
</script>
<style lang="scss">
.com_login {
  .el-input {
    margin-top: 5px;
  }
}
.el-input {
  input {
    height: 60px;
    border-radius: 0;
    border: none;
    border-bottom: 1px solid #dfe4eb !important;
    padding: 19px 0;
    color: #2f3133;
  }
  .el-input__suffix {
    display: flex;
    align-items: center;
    width: 80px;
    .el-input__suffix-inner {
      width: 100%;
      span {
        display: inline-block;
        width: 100%;
        cursor: pointer;
        height: 35px;
        line-height: 35px;
        color: #ced4db;
        font-size: 12px;
        border: none;
        border-radius: 2px;
      }
      .get_yzm {
        background: #edeff8;
        color: #3455d3;
      }
    }
  }
}
.img_yzm {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  .yzm_num {
    width: 160px;
    input {
      height: 40px;
      width: 100%;
      border-radius: 2px;
      border: 1px solid rgba(203, 207, 215, 1);
      padding-left: 15px;
    }
    input:focus {
      border-bottom: 1px solid rgba(203, 207, 215, 1) !important;
    }
    input:hover {
      border-bottom: 1px solid rgba(203, 207, 215, 1) !important;
    }
  }
  .yzm_img {
    width: 100px;
    height: 40px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .qiehuan {
    color: #3455d3;
    font-size: 14px;
    cursor: pointer;
  }
}

.com_login {
  .ant-input {
    height: 60px;
    border-radius: 0;
    border: none;
    border-bottom: 1px solid #dfe4eb;
    padding: 19px 0;
    color: #2f3133;
    // outline: none;
    outline-style: none !important;
  }
  .ant-input:focus {
    outline-style: none !important;
    box-shadow: none;
  }
  .el-button {
    width: 100%;
    height: 50px;
    margin-top: 30px !important;
    border-radius: 2px;
    font-size: 16px;
  }
  .el-button.is-disabled,
  .el-button.is-disabled:hover {
    background: #dae1e8;
    color: #ffffff;
    border-color: #dae1e8;
  }
}
</style>
<style lang="scss" scoped>
.com_login {
  width: 392px;
  background: #ffffff;
  border-radius: 2px;
  padding: 50px 30px;
  .login_title {
    font-size: 32px;
    color: #2f3133;
  }
  .register {
    margin-top: 20px;
    text-align: right;
    color: #5e6066;
    font-size: 16px;
    cursor: pointer;
  }
}
.zhuce {
  background: rgba(52, 85, 211, 1);
  border-radius: 2px;
  border-color: #3455d3;
  color: #ffffff;
}
.zhuce:hover,
.zhuce:focus {
  background: #2c4abb;
  border-color: #2c4abb;
  color: #ffffff;
}
</style>
